import { combineReducers } from 'redux';
import * as formReducers from './form';
import * as modalReducers from './modal';
import * as projectReducers from './project';

/**
  Root Reducer
  ---
  ./src/reducers/index.js

  - The root reducer is responsible for collecting all the
  reducers that we provide to our app's Redux data store.

  - In this file we can choose to use only the reducers that we absolutely need
  (in case this repo houses many apps).

  - Note: *this is included on the client only*.

  @returns {object} rootReducer
*/

const rootReducer = combineReducers({
  ...formReducers,
  ...modalReducers,
  ...projectReducers
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js